import React from 'react';
import PropTypes from 'prop-types';
import styles from './layout.module.css';
import SideBar from '../SideBar';
import { Grid, Container } from 'semantic-ui-react'

const Content = ({sections}) => {
  return <div>
   <div className={styles.contentFrame}>
    {sections}
  </div>
  </div>
}

const Layout = ({Left, Right}) => {
    return <Grid>
     <Grid.Row>
      <Grid.Column width={16}>
        <Grid>
          <Grid stackable>
            <Grid.Row >
              <Grid.Column width={11}>
                <Content sections={Left()} />
              </Grid.Column>
              <Grid.Column width={5}>
                <Right />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid>
      </Grid.Column>
      </Grid.Row>
    </Grid>
};

Layout.propTypes = {
  CompLeft: PropTypes.func,
  CompRight: PropTypes.func
}

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout/index.js